import type { MascotSubject } from './Mascot';

/**
 * Mascot display names — shared by the lesson helper, wonder cards, and
 * landing page. Lives outside Mascot.tsx so that file only exports
 * components (react-refresh/only-export-components).
 */
export const MASCOT_NAMES: Record<MascotSubject, string> = {
  mathematics:  'Hex',
  science:      'Blobby',
  technology:   'Pixel',
  engineering:  'Cogs',
  arts:         'Blossom',
  nature:       'Sprout',
  futureskills: 'Sprout',
};
